import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify'
import { UserInfoService } from '@eureka/domains/src/user-info'
import type { UploadResponse } from '@/types/upload'
import type { AgentUploadConfig, AgentUploadParams, AgentUploadStrategy } from './agent-upload-strategy'
import { BaseAgentUploadStrategy } from './base-agent-upload-strategy'

@injectable()
export class SarAgentUploadStrategy implements AgentUploadStrategy {
    constructor(
        @inject(BaseAgentUploadStrategy) private _baseAgentUploadStrategy: BaseAgentUploadStrategy,
        @inject(UserInfoService) private _userInfoService: UserInfoService
    ) {}

    async getLimit(): Promise<number> {
        const [isEnterpriseCommercial, isTrial, isFreeUser, isPro] = await Promise.all([
            this._userInfoService.getIsEnterpriseCommercialUser(),
            this._userInfoService.getIsTrialUser(),
            this._userInfoService.getIsFreeUser(),
            this._userInfoService.getIsPro()
        ])
        if (isFreeUser) return 2
        if (isPro) return 5
        if (isEnterpriseCommercial || isTrial) return 10

        return 2
    }

    getUploadConfig(): AgentUploadConfig {
        return this._baseAgentUploadStrategy.getUploadConfig()
    }

    async upload(params: AgentUploadParams): Promise<UploadResponse | undefined> {
        return this._baseAgentUploadStrategy.upload(params)
    }
}
